<template>
  <quill-editor
    :class="editorClass"
    :options="options"
    @input="handleOnInput"
    v-model="value"
  ></quill-editor>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ header: 1 }, { header: 2 }]
          ]
        }
      })
    },
    editorClass: {
      type: String,
      default: () => "border-black border-2 rounded-sm"
    }
  },
  data() {
    return {
      value: null
    };
  },

  components: {
    quillEditor
  },

  methods: {
    handleOnInput() {
      this.$emit("input", this.value);
    }
  }
};
</script>
